import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../context/Authcontext";
import ToastMessage from "./ToastMessage";
import ChangePasswordModal from "./ChangePasswordModal";
import toast from "react-hot-toast";
import axios from "axios";



export default function LoginReg({
  active,
  setactive,
  regactive,
  setregactive,
}) {
  const [registerFormData, setRegisterFormData] = useState({
    username: "",
    phoneNumber: "",
    pwd: "",
    cpassword: "",
    invitecode: "",
    imOver18: false,
    iAcceptAll: false,
  });
  const navigate = useNavigate();

  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "",
    password: "",
    iAcceptAll: false,
  });
  const { Register, login, setIsAuthenticated } = useContext(AuthContext);
  const [isPassVisible, setPassVisible] = useState(false);
  const [isConfPassViss, setConfPassVisible] = useState(false);
  // const [showChangePassword, setShowChangePassword] = useState(false);

  const [changePassActive, setChangePassActive] = useState(false);
const [changePassData, setChangePassData] = useState({
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
});
const [isNewPassVisible, setIsNewPassVisible] = useState(false);
const [isConfNewPassVisible, setIsConfNewPassVisible] = useState(false);

  const handleclearRegisterForm = () => {
    setRegisterFormData({
      username: "",
      phoneNumber: "",
      pwd: "",
      cpassword: "",
      invitecode: "",
      imOver18: false,
      iAcceptAll: false,
    });
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
  
    if (changePassData.newPassword !== changePassData.confirmPassword) {
      toast.error("New password and confirmation do not match");
      return;
    }
  
    try {
      const response = await axios.post(
        base_url + `/api/webapi/changePasswordLogin`,
        {
          password: changePassData.oldPassword,         // Matches backend `password`
          newPassWord: changePassData.newPassword,      // Matches backend `newPassWord`
          RePassWord: changePassData.confirmPassword,   // Matches backend `RePassWord`
                   // Assuming token is stored in localStorage
        },{
          withCredentials:true,
        }
      );
  
      if (response.data.status) {
        toast.success("Password changed successfully!");
  
        setChangePassData({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
       
        setChangePassActive(false);
        setactive(true)
      } else {
        toast.error(response.data.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Change password error:", error);
      toast.error("Something went wrong, please try again.");
    }
  };
  
  
  const handleclearLoginForm = () => {
    setLoginFormData({
      phoneNumber: "",
      password: "",
      iAcceptAll: false,
    });
  };
  const submitregister = (e) => {
    
    
    e.preventDefault();
    if (
      !registerFormData.username ||
      !registerFormData.phoneNumber ||
      !registerFormData.cpassword ||
      !registerFormData.pwd ||
      !registerFormData.invitecode ||
      !registerFormData.imOver18 ||
      !registerFormData.iAcceptAll
    ) {
      ToastMessage(0, "All fields are required!");
      return;
    }
    let { imOver18, iAcceptAll, ...data } = registerFormData;

    Register(data, function (res) {
      if (res.status) {
        ToastMessage(1, res.message);
        handleclearRegisterForm();
        // navigate('/'); 
        setactive(true);
        setregactive(false);
        
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  const submitlogin = (e) => {
    e.preventDefault();
    if (!loginFormData.phoneNumber || !loginFormData.password) {
      ToastMessage(0, "All fields are required!");
      return;
    }
    if(!loginFormData.iAcceptAll){
      ToastMessage(0,"Please Accept The Terms And Conditions");
      return;
    }
    let { iAcceptAll, ...data } = loginFormData;
    
    login(data, function (res) {
      console.log("response" , res);
      if (res.status) {
       
        setIsAuthenticated(true);
        ToastMessage(1, res.message);
        handleclearLoginForm();
   
        setactive(false);
        setregactive(false);
        if(res.loginStatus === 0){
          setChangePassActive(true)

        }
       
        // navigate('/'); 

      
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  return (
    <>
      {/* Login section */}
      <section
        style={{ zIndex: 1050 }}
        aria-hidden="true"
        className={`modal-backdrop fade show ${active ? "d-block" : "d-none"}  `  }
      ></section>
      <section
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`modal margin-top-responsive fade show ${active ? "d-block" : "d-none"} `}
      >
        <div
          role="document"
          className="modal-dialog"
          style={{ display: "flex", alignItems: "start",borderRadius:"13px" }}
        >
          <div className="modal-content ">
            <div
              _ngcontent-crs-c59=""
              appclickoutside=""
              className="border border-5 border-warning "
            >
              <button
                _ngcontent-crs-c59=""
                type="button"
                onClick={() => setactive(false)}
                className="close modal-close-button"
              >
                <i className="bi bi-x cross_icon text-black"></i>
              </button>
              <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
                <div
                  _ngcontent-crs-c59=""
                  className="text-center header-box d-flex align-items-start justify-content-center"
                >
                  <img
                    _ngcontent-crs-c59=""
                    className="top_dark logo-img"
                    alt="logo"
                    src="/assets/images/bigshotlogoblack.png"
                  />
                </div>
                <form
                  _ngcontent-crs-c59=""
                  onSubmit={submitlogin}
                  noValidate=""
                  className="ng-pristine ng-invalid"
                >
                  <div _ngcontent-crs-c59="" className="pt-5">
                    <span
                      _ngcontent-crs-c59=""
                      className="d-flex align-items-center form-floating"
                    >
                      <input
                        _ngcontent-crs-c59=""
                        autoComplete="username"
                        value={loginFormData.phoneNumber}
                        onChange={(e) =>
                          setLoginFormData({
                            ...loginFormData,
                            phoneNumber: e.target.value,
                          })
                        }
                        formcontrolname="username"
                        className="text-dark lm form-control ng-pristine ng-invalid"
                        style={{ height: "43px !important" }}
                        placeholder="Mobile No"
                       
                      />
                      <label _ngcontent-crs-c59="" className="floating-label">
                        User Name
                      </label>
                    </span>
                  </div>
                  <div _ngcontent-crs-c59="" className="pt-3">
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <span
                        _ngcontent-crs-c59=""
                        className="d-flex align-items-center form-floating"
                      >
                        <div
                          className={`p_hide_icon ${
                            isPassVisible ? "d-none" : ""
                          }`}
                          onClick={() => setPassVisible(!isPassVisible)}
                        >
                          <i className="bi bi-eye-slash"></i>
                        </div>
                        <div
                          className={`p_hide_icon ${
                            isPassVisible ? "" : "d-none"
                          }`}
                          onClick={() => setPassVisible(!isPassVisible)}
                        >
                          <i className="bi bi-eye-fill"></i>
                        </div>
                        <input
                          _ngcontent-crs-c59=""
                          value={loginFormData.password}
                          onChange={(e) =>
                            setLoginFormData({
                              ...loginFormData,
                              password: e.target.value,
                            })
                          }
                          formcontrolname="password"
                          className="text-dark lm form-control ng-pristine ng-invalid"
                          placeholder="Password"
                          type={isPassVisible ? "text" : "password"}
                        />
                        <label _ngcontent-crs-c59="" className="floating-label">
                          Password
                        </label>
                      </span>
                    </div>
                  </div>
                  <div
                    _ngcontent-crs-c59=""
                    className="pt-3 input_field_with_logo"
                  >
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <div
                        _ngcontent-crs-c59=""
                        className="policy row gap-1"
                        style={{ flexWrap: "nowrap" }}
                      >
                        <input
                          className="col-md-1 form-check-input shadow-none border-black mb-1"
                          type="checkbox"
                          id="imover18_1"
                          checked={loginFormData.iAcceptAll}
                          onChange={(e) =>
                            setLoginFormData({
                              ...loginFormData,
                              iAcceptAll: e.target.checked,
                            })
                          }
                        />
                        <h3
                          _ngcontent-crs-c59=""
                          className="col-md-11 text-center"
                        >
                          {" "}
                          I accept all the{" "}
                          <Link
                            _ngcontent-crs-c59=""
                            routerlinkactive="router-link-active"
                            style={{ textDecoration: "underline" }}
                          >
                            {" "}
                            Terms &amp; Conditions
                          </Link>
                        </h3>
                      </div>
                      <p
                        _ngcontent-crs-c59=""
                        className="loginLink m-0 text-right ng-star-inserted"
                      >
                        <Link
                          _ngcontent-crs-c59=""
                          style={{
                            position: "relative",
                            color: "#fff !important",
                          }}
                        >
                          Forgot Password?
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div _ngcontent-crs-c59="" className="pt-3">
                    <button
                      _ngcontent-crs-c59=""
                      type="submit"
                      className="login-btn"
                      // onClick={() => setChangePassActive(true)}
                    >
                      Login{" "}
                    </button>
                  </div>
                 
                </form>
               
                {/* <div _ngcontent-crs-c59="" className="pt-3">
                    <button
                      _ngcontent-crs-c59=""
                      type="submit"
                      className="login-btn"
                    >
                     Demo
                    </button>
                  </div> */}
                {/* <div _ngcontent-crs-c59="" className="pt-3">
                    <button
                      _ngcontent-crs-c59=""
                      type="submit"
                      className="login-btn1  d-flex justify-content-center gap-3   "
                    >
                      <i className="bi bi-android2 text-white"></i><p  style={{marginTop:"5px"}}>Download App</p>
                    </button>
                  </div> */}
                <div _ngcontent-crs-c59="" className="bottom_create">
                 
                  <p
                    _ngcontent-crs-c59=""
                    className="signup_add"
                    onClick={() => {
                      setactive(false);
                      setregactive(true);
                    }}
                  >
                   Create New Account
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section
        style={{ zIndex: 1050 }}
        aria-hidden="true"
        className={`modal-backdrop fade show ${
          regactive ? "d-block" : "d-none"
        } `}
      ></section>
      <section
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`modal margin-top-responsive fade show ${regactive ? "d-block" : "d-none"} `}
      >
        <div role="document" className="modal-dialog"
        style={{ display: "flex", alignItems: "start",borderRadius:"13px" }}>
          <div className="modal-content">
            <div
              _ngcontent-crs-c59=""
              appclickoutside=""
              className="modal-body  responsive-width"
            >
              <button
                _ngcontent-crs-c59=""
                type="button"
                onClick={() => setregactive(false)}
                className="close modal-close-button"
              >
                <i className="bi bi-x cross_icon text-black"></i>
              </button>
              <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
                <div
                  _ngcontent-crs-c59=""
                  className="text-center header-box d-flex align-items-start justify-content-start"
                >
                  <span className="text-black fs-3">SIGN UP</span>
                </div>
                <form
                  _ngcontent-crs-c59=""
                  onSubmit={submitregister}
                  noValidate=""
                  className=" ng-pristine ng-invalid"
                >
                  <div _ngcontent-crs-c59="" className="pt-3">
                    <span
                      _ngcontent-crs-c59=""
                      className="d-flex align-items-center form-floating"
                    >
                      <input
                        _ngcontent-crs-c59=""
                        autoComplete="username"
                        value={registerFormData.username}
                        onChange={(e) =>
                          setRegisterFormData({
                            ...registerFormData,
                            username: e.target.value,
                          })
                        }
                        formcontrolname="username"
                        className="text-dark lm form-control  ng-pristine ng-invalid"
                        placeholder="Username"
                      />
                      <label _ngcontent-crs-c59="" className="floating-label">
                        Name
                      </label>
                    </span>
                  </div>
                  <div _ngcontent-crs-c59="" className="pt-2">
                    <span
                      _ngcontent-crs-c59=""
                      className="d-flex align-items-center form-floating"
                    >
                      <input
                        _ngcontent-crs-c59=""
                      
                        value={registerFormData.phoneNumber}
                        onChange={(e) =>
                          setRegisterFormData({
                            ...registerFormData,
                            phoneNumber: e.target.value,
                          })
                        }
                        formcontrolname="username"
                        className="text-dark lm form-control  ng-pristine ng-invalid"
                        placeholder="Username"
                      />
                      <label _ngcontent-crs-c59="" className="floating-label">
                        User Name
                      </label>
                    </span>
                  </div>

                  <div _ngcontent-crs-c59="" className="pt-2">
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <span
                        _ngcontent-crs-c59=""
                        className="d-flex align-items-center form-floating"
                      >
                        <div
                          className={`p_hide_icon ${
                            isPassVisible ? "d-none" : ""
                          }`}
                          onClick={() => setPassVisible(!isPassVisible)}
                        >
                          <i className="bi bi-eye-slash"></i>
                        </div>
                        <div
                          className={`p_hide_icon ${
                            isPassVisible ? "" : "d-none"
                          }`}
                          onClick={() => setPassVisible(!isPassVisible)}
                        >
                          <i className="bi bi-eye-fill"></i>
                        </div>
                        <input
                          _ngcontent-crs-c59=""
                          autoComplete="current-password"
                          value={registerFormData.pwd}
                          onChange={(e) =>
                            setRegisterFormData({
                              ...registerFormData,
                              pwd: e.target.value,
                            })
                          }
                          formcontrolname="password"
                          className="text-dark lm form-control  ng-pristine ng-invalid"
                          placeholder="Password"
                          type={isPassVisible ? "text" : "password"}
                        />
                        <label _ngcontent-crs-c59="" className="floating-label">
                          Password
                        </label>
                      </span>
                    </div>
                  </div>
                  <div _ngcontent-crs-c59="" className="pt-2">
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <span
                        _ngcontent-crs-c59=""
                        className="d-flex align-items-center form-floating"
                      >
                        <div
                          className={`p_hide_icon ${
                            isConfPassViss ? "d-none" : ""
                          }`}
                          onClick={() => setConfPassVisible(!isConfPassViss)}
                        >
                          <i className="bi bi-eye-slash"></i>
                        </div>
                        <div
                          className={`p_hide_icon ${
                            isConfPassViss ? "" : "d-none"
                          }`}
                          onClick={() => setConfPassVisible(!isConfPassViss)}
                        >
                          <i className="bi bi-eye-fill"></i>
                        </div>

                        <input
                          _ngcontent-crs-c59=""
                          autoComplete="current-password"
                          value={registerFormData.cpassword}
                          onChange={(e) =>
                            setRegisterFormData({
                              ...registerFormData,
                              cpassword: e.target.value,
                            })
                          }
                          formcontrolname="password"
                          className="text-dark lm form-control  ng-pristine ng-invalid"
                          placeholder="Password"
                          type={isConfPassViss ? "text" : "password"}
                        />
                        <label _ngcontent-crs-c59="" className="floating-label">
                          Confirm Password
                        </label>
                      </span>
                    </div>
                  </div>
                  <div _ngcontent-crs-c59="" className="pt-2">
                    <span
                      _ngcontent-crs-c59=""
                      className="d-flex align-items-center form-floating"
                    >
                      <span _ngcontent-crs-c59="" className="user_icon">
                        <svg
                          _ngcontent-crs-c59=""
                          className="svg-inline--fa fa-user fa-w-14"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fa"
                          data-icon="user"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                          ></path>
                        </svg>
                      </span>
                      <input
                        _ngcontent-crs-c59=""
                        type="text"
                        value={registerFormData.invitecode}
                        onChange={(e) =>
                          setRegisterFormData({
                            ...registerFormData,
                            invitecode: e.target.value,
                          })
                        }
                        formcontrolname="username"
                        className="text-dark lm form-control  ng-pristine ng-invalid"
                        placeholder="Username"
                      />
                      <label _ngcontent-crs-c59="" className="floating-label">
                        Invitation Code
                      </label>
                    </span>
                  </div>
                  <div
                    _ngcontent-crs-c59=""
                    className="pt-3 input_field_with_logo"
                  >
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <div className="form-check">
                        <input
                          className="col-md-1 form-check-input shadow-none border-black"
                          type="checkbox"
                          onChange={(e) =>
                            setRegisterFormData({
                              ...registerFormData,
                              imOver18: e.target.checked,
                            })
                          }
                          checked={registerFormData.imOver18}
                          id="imover18"
                        />
                        <label
                          className="form-check-label text-black"
                          htmlFor="imover18"
                        >
                          I'm over 18
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-crs-c59=""
                    className="pt-2 input_field_with_logo"
                  >
                    <div _ngcontent-crs-c59="" className="inner-addon">
                      <div className="form-check">
                        <input
                          className="col-md-1 form-check-input shadow-none border-black"
                          type="checkbox"
                          onChange={(e) =>
                            setRegisterFormData({
                              ...registerFormData,
                              iAcceptAll: e.target.checked,
                            })
                          }
                          checked={registerFormData.iAcceptAll}
                          id="iaccept"
                        />
                        <label
                          className="form-check-label text-black"
                          htmlFor="iaccept"
                        >
                          I accept all the
                        </label>
                        <Link
                          className="ms-2 cursor-pointer"
                          style={{ textDecoration: "underline" }}
                        >
                          Terms &amp; Conditions
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div _ngcontent-crs-c59="" className="pt-2">
                    <button
                      _ngcontent-crs-c59=""
                      type="submit"
                      className="login-btn"
                    >
                      Register
                    </button>
                  </div>
                </form>
                <div _ngcontent-crs-c59="" className="bottom_create">
                  <p
                    _ngcontent-crs-c59=""
                    className="addition_className ng-star-inserted"
                  >
                    <Link
                      _ngcontent-crs-c59=""
                      style={{ textDecoration: "underline" }}
                    >
                      Already have an account?
                    </Link>
                  </p>
                  <p
                    _ngcontent-crs-c59=""
                    onClick={() => {
                      setactive(true);
                      setregactive(false);
                    }}
                    className="signup_add"
                  >
                    Login
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
  role="dialog"
  tabIndex="-1"
  aria-modal="true"
  className={`modal margin-top-responsive fade show ${changePassActive ? "d-block" : "d-none"}`}
>
  <div role="document" className="modal-dialog" style={{ display: "flex", alignItems: "start", borderRadius: "13px" }}>
    <div className="modal-content">
      <div className="modal-body responsive-width">
        {/* <button
          type="button"
          onClick={() => setChangePassActive(false)}
          className="close modal-close-button"
        >
          <i className="bi bi-x cross_icon text-black"></i>
        </button> */}
        <div className="px-5 form-box py-5">
          <div className="text-center header-box d-flex align-items-start justify-content-start">
            <span className="text-black fs-3">Change Password</span>
          </div>
          <form onSubmit={handleChangePassword}>
            {/* Old Password */}
            <div className="pt-3">
              <span className="d-flex align-items-center form-floating">
                <input
                  type="password"
                  value={changePassData.oldPassword}
                  onChange={(e) =>
                    setChangePassData({ ...changePassData, oldPassword: e.target.value })
                  }
                  className="form-control text-white bg-black rounded-3 give-border-radius"
                  placeholder="Old Password"
                />
                <label className="floating-label">Old Password</label>
              </span>
            </div>

            {/* New Password */}
            <div className="pt-3">
              <span className="d-flex align-items-center form-floating">
                <div
                  className={`p_hide_icon ${isNewPassVisible ? "d-none" : ""}`}
                  onClick={() => setIsNewPassVisible(true)}
                >
                  <i className="bi bi-eye-slash"></i>
                </div>
                <div
                  className={`p_hide_icon ${isNewPassVisible ? "" : "d-none"}`}
                  onClick={() => setIsNewPassVisible(false)}
                >
                  <i className="bi bi-eye-fill"></i>
                </div>
                <input
                  type={isNewPassVisible ? "text" : "password"}
                  value={changePassData.newPassword}
                  onChange={(e) =>
                    setChangePassData({ ...changePassData, newPassword: e.target.value })
                  }
                  className="form-control text-white bg-black give-border-radius"
                  placeholder="New Password"
                />
                <label className="floating-label">New Password</label>
              </span>
            </div>

            {/* Confirm New Password */}
            <div className="pt-3">
              <span className="d-flex align-items-center form-floating">
                <div
                  className={`p_hide_icon ${isConfNewPassVisible ? "d-none" : ""}`}
                  onClick={() => setIsConfNewPassVisible(true)}
                >
                  <i className="bi bi-eye-slash"></i>
                </div>
                <div
                  className={`p_hide_icon ${isConfNewPassVisible ? "" : "d-none"}`}
                  onClick={() => setIsConfNewPassVisible(false)}
                >
                  <i className="bi bi-eye-fill"></i>
                </div>
                <input
                  type={isConfNewPassVisible ? "text" : "password"}
                  value={changePassData.confirmPassword}
                  onChange={(e) =>
                    setChangePassData({ ...changePassData, confirmPassword: e.target.value })
                  }
                  className="form-control text-white bg-black give-border-radius"
                  placeholder="Confirm Password"
                />
                <label className="floating-label">Confirm Password</label>
              </span>
            </div>

            <div className="pt-4">
              <button type="submit" style={{backgroundColor:"#ffc107" , width:"100%" , height:"7vh" , borderRadius:"5px" , border:"none" , color:"black"  }} className="login-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>


      
    </>
  );
}
